
import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar.tsx';
import HomePage from './components/HomePage.tsx';
import PlatformPage from './components/PlatformPage.tsx';
import PolicyNowPage from './components/PolicyNowPage.tsx';
import SmartCityPage from './components/SmartCityPage.tsx';
import TrustPage from './components/TrustPage.tsx';
//import AiAssistant from './components/AiAssistant.tsx';
import Footer from './components/Footer.tsx';

const App: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<'home' | 'platform' | 'policynow' | 'smartcity' | 'trust'>('home');

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace('#', '');
      if (['platform', 'policynow', 'smartcity', 'trust'].includes(hash)) {
        setCurrentPage(hash as any);
      } else {
        setCurrentPage('home');
      }
      window.scrollTo(0, 0);
    };

    window.addEventListener('hashchange', handleHashChange);
    handleHashChange();

    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const navigateTo = (page: string) => {
    window.location.hash = page === 'home' ? '' : page;
  };

  return (
    <div className="min-h-screen selection:bg-brand-blue/30 selection:text-white">
      <Navbar onNavigate={navigateTo} activePage={currentPage} />
      
      <main className="transition-opacity duration-1000">
        {currentPage === 'home' && <HomePage />}
        {currentPage === 'platform' && <PlatformPage />}
        {currentPage === 'policynow' && <PolicyNowPage />}
        {currentPage === 'smartcity' && <SmartCityPage />}
        {currentPage === 'trust' && <TrustPage />}
      </main>

      <Footer />
      {/* <AiAssistant > */}
    </div>
  );
};

export default App;